















import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'FileIcon',
  props: {
    type: String,
    tooltip: String,
    color: String,
  },
  setup(props) {
    const icon = computed(() => {
      if (!props.type) {
        return ''
      }
      switch (props.type.toLowerCase()) {
        case 'pdf':
          return 'mdi-file-pdf-box'
        case 'video':
          return 'mdi-file-video'
        case 'audio':
          return 'mdi-file-music'
        case 'image':
          return 'mdi-file-image'
        case 'zip':
          return 'mdi-folder-zip'
        case 'link':
          return 'mdi-file-link'
        case 'word':
          return 'mdi-file-word'
        case 'excel':
          return 'mdi-microsoft-excel'
        default:
          return 'mdi-file'
      }
    })

    return { icon }
  },
})
